import React, { useState, Fragment, useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getInt } from 'utils/functions';
import ApprovalTypeLevelContainer from './ApprovalTypeLevelContainer';
import { areas } from '../../../../../constants/areas';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import ApprovalTypeLevelHeader from './header/ApprovalTypeLevelHeader';
import ApprovalTypeLevelHeaderLinks from './header/ApprovalTypeLevelHeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = ({ getElemByAreaKey }) => {
  const match = useRouteMatch();
  const historyContext = useHistoryWithContext();
  const [disabledSave, setDisabledSave] = useState(true);
  const [onSave, setOnSave] = useState({ fn: () => {} });
  const approvalTypeId = match.params.approvalTypeId && getInt(match.params.approvalTypeId);
  const siteId = match.params.siteId && getInt(match.params.siteId);
  const approvalTypeLevelId = match.params.approvalTypeLevelId && getInt(match.params.approvalTypeLevelId);

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setOnSave({ fn });
    setDisabledSave(disabledSave);
  }, []);

  const onClose = useCallback(
    (approvalTypeId, siteId) => {
      historyContext.push(`/approvalTypes/${approvalTypeId}/${siteId}`);
    },
    [historyContext]
  );

  const onRedirect = useCallback(
    (approvalTypeId, approvalTypeLevelId, siteId) => {
      historyContext.push(`/approvalTypes/${approvalTypeId}/${siteId}/approvalTypeLevel/${approvalTypeLevelId}/${siteId}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <ApprovalTypeLevelHeader></ApprovalTypeLevelHeader>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <ApprovalTypeLevelHeaderLinks
          approvalTypeId={approvalTypeId}
          siteId={siteId}
          onClose={onClose}
          onSave={onSave.fn}
          disabledSave={disabledSave}
        />
      </Portal>
      <ApprovalTypeLevelContainer
        approvalTypeId={approvalTypeId}
        siteId={siteId}
        approvalTypeLevelId={approvalTypeLevelId}
        onSaveFnChanged={onSaveFnChanged}
        onRedirect={onRedirect}
      />
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
